import React, { useCallback, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  apiError,
  changeMenuActived,
  isTransactionNotFound,
  isTransactionWithError,
  loginUserByToken,
  logoutUser,
  showTopbarInsideAction,
} from "../store/actions";
import BizinBackend from "../helpers/bizin_helper";
import { LOGIN } from "../helpers/routes_helper";
import { authProtectedRoutes } from './routes';
import { AuthProtectedContext } from './AuthProtectedContext';
import useGetCsrfToken from '../Hooks/useGetCsrfToken';
import { decode } from 'js-base64';

const regexTransation = /^[A-Z][A-Z0-9_]*[A-Z0-9]$/;

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const csrfToken = useGetCsrfToken()
  const { user, menusSidebar, isIframePage, isModalPage } = useSelector((state) => ({
    user: state.login.profile,
    menusSidebar: state.login.user,
    isIframePage: state.Layout.isIframePage,
    isModalPage: state.Layout.isModalPage
  }))

  const { pathname, search } = useLocation()

  const [isLoading, setIsLoading] = useState(false)
  const [transactionData, setTransactionData] = useState([])

  const getUserByToken = async (token) => {
    const data = await BizinBackend.executeProcedure(
      { 1: decode(token), 2: 'DEFENDER' }, 
      'FRONT_Token_Acesso_Verificar', 
      csrfToken
    );
    
    if(data[0] && data[0]?.statusCode == 200){
      const { Email } = data[0]
      dispatch(loginUserByToken({
        email: Email,
        token: decode(token),
        _csrf: csrfToken
      }));
    }else{
      dispatch(isTransactionWithError({ payload: {status: 401, statusText: "Unauthorized."} }))
    }
  }

  const checkUser = async () => {
    const params = new URLSearchParams(search);
    if (user && user?.ID_Usuario && menusSidebar?.access_token) {
      if (
        params.get("token") &&
        menusSidebar?.resultset_1[0].Token_Acesso !==
          decode(params.get("token"))
      ) {
        dispatch(logoutUser(null));
        getUserByToken(params.get("token"));
      } else {
        try {
          await BizinBackend.checkAccessToken(menusSidebar.access_token);
        } catch (error) {
          dispatch(
            apiError(
              `Sessão expirada. ${isModalPage || isIframePage ? "Por favor recarrege a pagina" : ""}`,
            ),
          );
          dispatch(logoutUser(null));
        }
      }
    }
  };

  const findMenuInTree = (menus, targetCodigo) => {
    for (const menu of menus || []) {
      if (menu?.Codigo_Transacao?.toUpperCase() === targetCodigo.toUpperCase() && menu?.Disponivel === 'S') {
        return menu;
      }
      if (menu.childrens && menu.childrens.length > 0) {
        const foundInChildren = findMenuInTree(menu.childrens, targetCodigo);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
    return null;
  };

  const checkPathname = async () => {
    try {
      let id_menu = null;

      if (menusSidebar && menusSidebar?.resultset_4) {
        const pathnameUpper = pathname.replace('/', '').toUpperCase();
        const menuAtivo = findMenuInTree(menusSidebar.resultset_4, pathnameUpper);

        if (menuAtivo && menuAtivo.ID_Menu) {
          id_menu = menuAtivo.ID_Menu;
        }
      }

      if (id_menu === null) {
        const savedMenu = localStorage.getItem('lastClickedTopInsiderMenu');
        if (savedMenu) {
          try {
            const parsedMenu = JSON.parse(savedMenu);
            if (parsedMenu && parsedMenu.id) {
              id_menu = parsedMenu.id;
            }
          } catch (e) {
          }
        }
      }

      const params = {
          1: user.ID_Usuario,
          2: user.Cultura_Idioma,
          3: pathname.replace('/', ''),
          4: search.replace('?', '') || null,
          5: id_menu
      };

      let data = await BizinBackend.executeProcedure(
        params,
        'FRONT_Workspace_Obter_Parametros_Transacao',
        csrfToken,
        menusSidebar?.access_token
      );

      if(data && data?.length && !data?.responseBackend){
        if((data[0] && data[0]?.statusCode) && !authProtectedRoutes.filter(route => route.path.includes(pathname)).length) {
           dispatch(isTransactionNotFound(true))
          }else {
          dispatch(isTransactionNotFound(false))
          setTransactionData(data)

          const menuAplicacaoItem = data?.find(item => item.Chave_Transacao_Componente === 'MENU_APLICACAO');
          const idMenuAplicacaoItem = data?.find(item => item.Chave_Transacao_Componente === 'ID_MENU_APLICACAO');

          if (!idMenuAplicacaoItem?.Valor_Componente) {
            localStorage.removeItem('lastClickedTopInsiderMenu');
            dispatch(showTopbarInsideAction({ isActive: 'N', payload: [], id: null }));
          } else if (menuAplicacaoItem?.Valor_Componente) {
            try {
              let menuData = menuAplicacaoItem.Valor_Componente;
              if (typeof menuData === 'string') {
                menuData = JSON.parse(menuData);
              }

              if (Array.isArray(menuData) && menuData.length > 0) {
                const transformedData = menuData.map(item => {
                  const hasChildren = menuData.some(child =>
                    Number(child.ID_Menu_Pai) === Number(item.ID_Menu)
                  );
                  return {
                    ...item,
                    Transacao: item.Descricao || item.Transacao,
                    URL_Transacao: item.Codigo_Transacao || item.URL_Transacao,
                    Icone_Transacao: item.Icone_Transacao || item.Icone_Item,
                    Disponivel: item.Ativo_Menu === "S" ? "S" : "N",
                    Dropdown: (item.Chave_Tipo_Item_Menu === "ITEM_FANTASMA" || hasChildren) ? "S" : "N"
                  };
                });

                const idMenuAplicacao = idMenuAplicacaoItem?.Valor_Componente
                  ? Number(idMenuAplicacaoItem.Valor_Componente)
                  : id_menu;

                const menu = {
                  id: idMenuAplicacao,
                  isActive: "S",
                  payload: transformedData,
                };

                dispatch(showTopbarInsideAction(menu));
              }
            } catch (e) {
            }
          } else {
            const idMenuRetornado = Number(idMenuAplicacaoItem.Valor_Componente);
            let cacheMenu = null;

            try {
              const savedMenu = localStorage.getItem('lastClickedTopInsiderMenu');
              if (savedMenu) {
                cacheMenu = JSON.parse(savedMenu);
              }
            } catch (e) {
            }

            if (cacheMenu?.id === idMenuRetornado && cacheMenu?.payload?.length > 0) {
              dispatch(showTopbarInsideAction({
                id: cacheMenu.id,
                isActive: "S",
                payload: cacheMenu.payload
              }));
            } else {
              localStorage.removeItem('lastClickedTopInsiderMenu');
              dispatch(showTopbarInsideAction({ isActive: 'N', payload: [], id: null }));
            }
          }
        }
      }else{
        dispatch(isTransactionWithError({
          payload: data
        }))
      }

    } catch (error) {
      if([401, 403].includes(error.status)) dispatch(logoutUser())
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(
    useCallback(() => {
      checkUser()
    }, [user]),
    []
  )

  useEffect(() => {
    setTransactionData([])
    
    if (user && new RegExp(regexTransation).test(pathname.toUpperCase().replace('/', ''))) {
      setIsLoading(true)
      checkPathname()
    }else{
      dispatch(isTransactionNotFound(true))
    }

    if (menusSidebar && menusSidebar?.resultset_4) {
      const pathnameUpper = pathname.replace('/', '').toUpperCase()
      const menuAtivo = findMenuInTree(menusSidebar.resultset_4, pathnameUpper);

      if (menuAtivo) {
        dispatch(changeMenuActived(menuAtivo))
      }
    }
  }, [pathname])

  if (!user && isIframePage && window) {
    window.location.href = `${window.location.origin}${window.location.pathname + window.location.search}`;
  }

  if (!user && window) {
    localStorage.setItem('UrlOriginNoAuth', window.location.pathname + window.location.search)
    return (
      <Navigate to={{ pathname: LOGIN, state: { from: props.location } }} />
    )
  }

  if (user.Alterar_Senha === 'S') {
    return (
      <Navigate to={{ pathname: '/new-pw', state: { from: props.location } }} />
    )
  }

  return (
    <AuthProtectedContext.Provider value={{ transactionData, isLoading }}>
      {props.children}
    </AuthProtectedContext.Provider>
  )
}

export { AuthProtected }
